import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { StakeService } from './stake.service';

export function StakeFactory(): StakeService {
  return new StakeService();
}

export function provideStake(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: StakeService,
      useFactory: StakeFactory,
      deps: []
    }
  ]);
}
